import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Card from '../components/ui/Card';
import Logo from '../components/ui/Logo';
import { APP_CONFIG } from '../data/constants.jsx';

const Register = () => {
  const { t } = useTranslation();
  const [googleAuthUrl, setGoogleAuthUrl] = useState('');

  // Get Google OAuth URL dynamically
  useEffect(() => {
    const getGoogleAuthUrl = () => {
      const protocol = window.location.protocol;
      const hostname = window.location.hostname;

      // Check for Coder environment
      if (hostname.includes('coder.') || hostname.includes('--')) {
        const backendHost = hostname.replace(/5174--/g, '8898--').replace(/5173--/g, '8898--');
        return `${protocol}//${backendHost}/api/accounts/google/login/`;
      }

      // Check for localhost
      if (hostname === 'localhost' || hostname === '127.0.0.1') {
        return `${protocol}//${hostname}:8898/api/accounts/google/login/`;
      }

      // Production (relative URL through nginx)
      return '/api/accounts/google/login/';
    };

    setGoogleAuthUrl(getGoogleAuthUrl());
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />

      <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex items-center justify-center px-4 py-8">
        <div className="w-full max-w-md">
          {/* Header */}
          <div className="text-center mb-8">
            <Link to="/" className="inline-flex items-center space-x-3 mb-6 hover:opacity-80 transition-opacity">
              <Logo className="w-12 h-12 rounded-xl" />
              <div>
                <h1 className="font-bold text-2xl text-gray-800">{APP_CONFIG.name}</h1>
                <p className="text-sm text-gray-600">{t('footer.appNameBengali')}</p>
              </div>
            </Link>
            <h2 className="text-2xl font-bold text-gray-800 mb-2">{t('auth.createAccount')}</h2>
            <p className="text-gray-600">
              {t('auth.registerWithGoogle')}
            </p>
          </div>

          <Card className="p-0 overflow-hidden">
            {/* Auth Tabs */}
            <div className="flex border-b border-gray-200">
              <Link
                to="/login"
                className="flex-1 text-center py-4 px-6 font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-50 transition-colors rounded-tl-lg"
              >
                {t('auth.login') || 'লগইন'}
              </Link>
              <div className="flex-1 text-center py-4 px-6 font-medium text-white bg-gradient-to-r from-green-500 to-blue-500 cursor-default rounded-tr-lg">
                {t('auth.register') || 'রেজিস্টার'}
              </div>
            </div>

            <div className="p-8">
            {/* Google Sign Up Button */}
            <a
              href={googleAuthUrl}
              className="w-full flex items-center justify-center gap-3 px-4 py-4 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors bg-white text-gray-700 font-medium shadow-sm hover:shadow-md"
            >
              <svg className="w-6 h-6" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              <span className="text-base">{t('auth.signUpWithGoogle')}</span>
            </a>

            {/* Info Text */}
            <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
              <p className="text-sm text-blue-800 text-center">
                {t('auth.registerInfo')}
              </p>
            </div>

            {/* Back to Homepage */}
            <div className="mt-4 text-center">
              <Link
                to="/"
                className="text-gray-600 hover:text-gray-800 text-sm transition-colors"
              >
                ← {t('nav.backToHome')}
              </Link>
            </div>
            </div>
          </Card>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Register;
